export enum PlayerEvent {
  // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events
  click = 'click',
  ended = 'ended',
  error = 'error',
  fullscreenchange = 'fullscreenchange',
  loadeddata = 'loadeddata',
  loadedmetadata = 'loadedmetadata',
  loadstart = 'loadstart',
  pause = 'pause',
  play = 'play',
  playerresize = 'playerresize',
  playing = 'playing',
  progress = 'progress',
  ratechange = 'ratechange',
  seeked = 'seeked',
  seeking = 'seeking',
  stalled = 'stalled',
  suspend = 'suspend',
  timeupdate = 'timeupdate', // makes logging *way* too noisy
  touchend = 'touchend',
  volumechange = 'volumechange',
  waiting = 'waiting',

  // https://videojs.github.io/videojs-contrib-ads/integrator/api.html
  adend = 'adend',
  adsadstarted = 'ads-ad-started',
  adserror = 'adserror',
  adskip = 'adskip',
  adspodstarted = 'ads-pod-started',
  adsready = 'adsready',
  adstart = 'adstart',
  adtimeout = 'adtimeout',
  contentchanged = 'contentchanged',
  contentresumed = 'contentresumed',
  nopostroll = 'nopostroll',
  nopreroll = 'nopreroll',
  readyforpostroll = 'readyforpostroll',
  readyforpreroll = 'readyforpreroll',

  // https://github.com/brightcove/videojs-playlist/blob/master/docs/api.md#events
  beforeplaylistitem = 'beforeplaylistitem',
  duringplaylistchange = 'duringplaylistchange',
  playlistchange = 'playlistchange',
  playlistitem = 'playlistitem',
  playlistsorted = 'playlistsorted',

  // undocumented, but it exists...
  adsRequest = 'ads-request'
}


// https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdEvent.Type.AD_BREAK_READY
export enum IMAEvent {
  adBreakReady = 'adBreakReady',
  adMetadata = 'adMetadata',
  adProgress = 'adProgress',
  allAdsCompleted = 'allAdsCompleted',
  click = 'click',
  complete = 'complete',
  contentPauseRequested = 'contentPauseRequested',
  contentResumeRequested = 'contentResumeRequested',
  durationChange = 'durationChange',
  expandedChanged = 'expandedChanged',
  firstquartile = 'firstquartile',
  impression = 'impression',
  interaction = 'interaction',
  linearChanged = 'linearChanged',
  loaded = 'loaded',
  log = 'log',
  midpoint = 'midpoint',
  mute = 'mute',
  pause = 'pause',
  resume = 'resume',
  skip = 'skip',
  skippableStateChanged = 'skippableStateChanged',
  start = 'start',
  thirdquartile = 'thirdquartile',
  userClose = 'userClose',
  volumeChange = 'volumeChange'
}

export enum ModalEvent {
  beforemodalfill = 'beforemodalfill',
  beforemodalopen = 'beforemodalopen',
  modalclose = 'modalclose',
  modalopen = 'modalopen'
}

export enum CustomPlayerEvent {
  activePlayerChange = 'activePlayerChange'
}

export enum AppEvent {
  imaLoaded = 'imaLoaded',
  imaStart = 'imaStart',
  initIMA = 'initIMA',
  initLauncher = 'initLauncher',
  initPlacement = 'initPlacement',
  initPlayer = 'initPlayer',
  initVJS = 'initVJS',
  vjsAdsError = 'vjsAdsError',
  vjsEnded = 'vjsEnded',
  vjsError = 'vjsError',
  vjsLoadedData = 'vjsLoadedData',
  initPlayerError = 'initPlayerError'
}
